import styled from "styled-components";

interface IProps {
  children: JSX.Element | JSX.Element[];
}

const StyledDiv = styled.div`
  width: 100%;
  > * {
    display: block;
    width: 100%;
  }
`;

const Field = ({ children }: IProps) => {
  return <StyledDiv>{children}</StyledDiv>;
};

export default Field;
